// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fsyypxpydalatnrvyxqv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZzeXlweHB5ZGFsYXRucnZ5eHF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYyNTY1OTgsImV4cCI6MjA2MTgzMjU5OH0._t7nMRRYDvWRt-962V4VyyOeI9nabjQrlncChOtS7cI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);